//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PopUpSelectAddress",

  computed: {
    isOpen: function () {
      return this.$store.state["cart-new"]?.isOpenPopUpSelectAddress || false
    },

    selectedDeliveryMethods: function () {
      return this.$store.state["cart-new"]?.selectedDeliveryMethods || []
    },
    activeSelectedDeliveryMethod: function () {
      return this.$store.state["cart-new"]?.selectedDeliveryMethod
    },

    buttonSubmitLabel: function () {
      return "Привезти сюда"
    },
    buttonSubmitDisabled: function () {
      if (this.activeSelectedDeliveryMethod === "pickup") {
        return !Boolean(Object.keys(this.$store.state["cart-new"]?.pickupPointsInfo || {}).length)
      }
      if (this.activeSelectedDeliveryMethod === "delivery") {
        const notFullAddress = !Boolean(this.$store.state["cart-new"]?.deliveryInfo?.fullAddress);
        const notSelectedCourierId = !Boolean(this.$store.state["cart-new"]?.deliveryInfo?.courierId);

        return Boolean(notFullAddress || notSelectedCourierId)
      }

      return true
    }
  },

  components: {
    PickupPoints: () => import("./pickup-method/PickupPoints"),
    FormSelected: () => import("./pickup-method/FormSelected"),
    FormEnterAddress: () => import("./delivery-method/FormEnterAddress"),
    FormSelectCourier: () => import("./delivery-method/FormSelectCourier"),

    YandexMapPickup: () => import("./pickup-method/Map"),
    YandexMapDelivery: () => import("./delivery-method/Map")
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style = '';
      }
    }
  },

  methods: {
    closePopUpSelectAddress: function () {
      if (this.$store.state?.["cart-new"]?.popUpConfirmNotifyMessage) {
        this.$store.commit("cart-new/setIsPopUpConfirmNotifyMessage", true);
        return
      }
      this.$store.commit("cart-new/changeOpenPopUpSelectAddress", false);
    },
    resetStateSelectedAndClose: async function () {
      const type = this.$store.state["cart-new"]?.selectedDeliveryMethod;
      // if (type === "pickup") {
      //   await this.$store.commit("cart-new/resetPickupPointsInfo");
      // }
      // if (type === "delivery") {
      //   await this.$store.commit("cart-new/resetDeliveryInfo");
      // }
      this.$store.commit("cart-new/closePopUpSelectAddressReset", {
        type: type
      });
    },
    changeActiveSelectedDeliveryMethod: function (method) {
      this.$store.commit("cart-new/changeSelectedDeliveryMethod", method);
    },
  }
}
